import { toast as rht } from "react-hot-toast";
import type { ToastOptions } from "react-hot-toast";

const options: ToastOptions = {
  duration: 3000,
  position: "top-right",
};


type ToastPromiseParams<T> = {
loading:  string;
success: string | ((data: T) => string);
error: string | ((err: any)=> string);
}

const success = (msg: string) => {
  return rht.success(msg, options);
};

const error = (msg: string) => {
  return rht.error(msg, options);
};

// Custom warning using icon and styles
const warning = (msg: string) => {
  return rht(msg, {
    ...options,
    icon: "⚠️",
    style: {
      background: "#ffffff",
      color: "#92400e",
    },
  });
};

const promise = <T = any>( myPromise: Promise<T>, msgObj: ToastPromiseParams<T>) => {
  return rht.promise(myPromise, msgObj, options);
};

const toast = {
  success,
  error,
  warning,
  promise,
};

export default toast;
